"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ItemOfferHealthParamsSchema = void 0;
const zod_1 = require("zod");
const _1 = require(".");
const __1 = require("..");
exports.ItemOfferHealthParamsSchema = zod_1.z.object({
    storeId: __1.ShortStringSchema.uuid(),
    offers: _1.ItemOfferSchema.partial(),
});
//# sourceMappingURL=item-offer-health.js.map